export default {"src":"/_next/static/media/simi.d1222001.svg","height":18,"width":18};